<template>
  <div
    class="text-action-default-hi rounded-sm flex items-center overflow-hidden pl-24"
  >
    <!-- Should use InputText when search type is available [DSB-2846] -->
    <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
    <input
      :id="inputId"
      ref="input"
      autocomplete="off"
      autocorrect="off"
      class="body-2 h-36 flex-1 appearance-none outline-none"
      data-qa="search-bar-input"
      :name="inputName"
      :placeholder="i18n(translations.textboxPlaceholder)"
      role="searchbox"
      type="text"
      :value="value"
      @blur="blurHandler"
      @focus="handleFocus"
      @input="changeHandler"
      @keydown.down.prevent="specialKeyHandler"
      @keydown.enter.prevent="submitHandler"
      @keydown.esc.prevent="resetHandler"
      @keydown.up.prevent="specialKeyHandler"
    />
    <button
      v-show="value"
      :aria-label="i18n(translations.resetSearchButtonAriaLabel)"
      class="text-action-default-hi flex h-32 w-32 cursor-pointer items-center justify-center transition-colors duration-100 hover:text-action-default-hi-hover"
      type="reset"
      @click="resetHandler"
    >
      ✕
    </button>

    <button
      :aria-label="i18n(translations.searchButtonAriaLabel)"
      class="text-action-default-hi flex h-32 w-32 cursor-pointer items-center justify-center transition-colors duration-100 hover:text-action-default-hi-hover"
      type="submit"
      @click="submitHandler"
    >
      <IconSearch size="small" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconSearch } from '@ds/icons/IconSearch'

import translations from './Textbox.translations'

const i18n = useI18n()

const emit = defineEmits([
  'close-listbox',
  'change',
  'submit',
  'keydown',
  'focus',
])

const props = withDefaults(
  defineProps<{
    value: string
    inputName?: string
    inputId: string
  }>(),
  {
    inputName: 'q',
  },
)

const input = ref<HTMLInputElement | null>(null)

function blurHandler() {
  emit('close-listbox')
}

function submitHandler() {
  emit('submit', props.value)
}

function changeHandler(e: Event) {
  const { target } = e
  const { value } = target as HTMLInputElement
  emit('change', value)
}

function specialKeyHandler({ code }: { code: string }) {
  if (code === 'ArrowUp') {
    emit('keydown', -1)
  } else if (code === 'ArrowDown') {
    emit('keydown', 1)
  }
}

function handleFocus() {
  input.value?.focus()
  emit('focus')
}

function resetHandler() {
  emit('change', '')
  handleFocus()
}

function hydrated() {
  if (input.value === document.activeElement) {
    handleFocus()
  }
}

onMounted(() => {
  hydrated()
})
</script>
